//
//
//
//
//
//
//
//

import ClientProfilePreview from '@/components/client/ClientProfilePreview'
import FetchClient from '@/mixins/FetchClient'
import Pageview from '@/mixins/Pageview'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ClientProfileSlugPage',
  auth: false,
  components: {
    ClientProfilePreview
  },
  mixins: [FetchClient, Pageview]
}
